<template>
  <div class="rbu-item-module-data-points">
    <NsrItemModuleDataPoint
      v-for="(datapoint, idx) in datapoints"
      :datapoint="datapoint"
      :idx="idx"
      @input="onDataPointUpdate(idx, $event)"
      @delete="onDataPointDelete(idx)"
    ></NsrItemModuleDataPoint>
  </div>
</template>

<script>
import NsrItemModuleDataPoint from "@/components/nsr/NsrItemModuleDataPoint.vue";

export default {
  name: "NsrItemModuleDataPoints",
  components: { NsrItemModuleDataPoint },
  props: {
    item: Object,
    datapoints: Array,
  },
  setup(props, { root, emit }) {
    const onDataPointUpdate = function (idx, evt) {
      let dataPoints = _.concat(props.datapoints || [], []);
      dataPoints.splice(idx, 1, {
        ...props.datapoints[idx],
        ...evt,
      });
      emit("input", dataPoints);
    };

    const onDataPointDelete = function (idx) {
      let dataPoints = _.concat(props.datapoints || [], []);
      dataPoints.splice(idx, 1);
      emit("input", dataPoints);
    };

    return {
      onDataPointUpdate,
      onDataPointDelete,
    };
  },
};
</script>
